import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const CategoryService = createApi({
	reducerPath: "CategoriesContent",
	baseQuery: fetchBaseQuery({
		baseUrl: "https://flit-backend.developer-ourbase-camp.com/api/",
	}),
	endpoints: (builder) => {
		return {
			categories: builder.query({
				query: () => {
					return {
						url: "categories",
						method: "GET",
					};
				},
			}),
			brands: builder.query({
				query: () => {
					return {
						url: "brands",
						method: "GET",
					};
				},
			}),
		};
	},
});
export const { useCategoriesQuery, useBrandsQuery } = CategoryService;
export default CategoryService;
